<template>
    <section class="recipe">
        <div class="container">
            <div class="row">
                <!-- filter column -->
                <div class="col s12 m4 l3 filter-card" v-show="!is_category_loading">
                    <div class="row">
                        <div class="col s12">
                            <h4>Filter</h4>
                            <ul class="collapsible expandable z-depth-0">
                                <li v-for="recipe_category_parent in recipe_categories" v-if="!recipe_category_parent.parent_id">
                                    <div class="collapsible-header">{{ recipe_category_parent.name }} <i class="material-icons">keyboard_arrow_right</i></div>
                                    <div class="collapsible-body">
                                        <p v-for="recipe_category_child in recipe_categories" v-if="recipe_category_parent.id === recipe_category_child.parent_id && recipe_category_child.recipes.length > 0">
                                            <label>
                                                <input type="checkbox" :value="recipe_category_child.id" v-model="recipe_category_filter"/>
                                                <span>{{ recipe_category_child.name }}</span>
                                            </label>
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="col s12">
                            <a class="waves-effect waves-light btn clear-all-btn" v-on:click="clearAll">Clear all</a>
                        </div>
                    </div>
                </div>
<!--                &lt;!&ndash;loading category &ndash;&gt;-->
<!--                <div class="col s12 m3 center-align" v-show="is_category_loading">-->
<!--                    <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true" style="font-size: 2.5rem;"></i>-->
<!--                </div>-->
                <!-- recipe column-->
                <div class="col s12 m8 l9 filter_list" v-if="!is_recipe_loading">
                    <div class="row" v-for="category in category_recipes" v-if="category.recipes.length > 0">
                        <div class="col s12">
                            <!-- section container -->
                            <div class="row">
                                <div class="col s12">
                                    <div class="category-title">{{ category.name }}</div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col s6 m6 l4" v-for="recipe in category.recipes">
                                    <recipe-card :recipe="recipe"></recipe-card>
                                </div>
                            </div>
                            <div class="row" v-if="category.recipes.length < category.recipe_count">
                                <div class="col s12 center-align">
                                    <a class="waves-effect waves-light btn" v-if="category.skip < category.recipe_count" v-on:click="load_more(category)">Load More</a>
                                </div>
                            </div>
                            <hr>
                        </div>
                    </div>
                </div>
                <div class="col s12 m8 l9" v-if="is_recipe_loading">
                    <div class="row">
                        <div class="col s12 center-align">
                            <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true" style="font-size: 2.5rem;"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import RecipeCardComponent from './partials/RecipeCardComponent';

    export default {
        name: "RecipeComponent",
        props: [
            'siteUrl',
            'getRecipeCategoriesUrl',
            'getCategoryRecipeListUrl',
            'getCategoryRecipeLoadUrl',
            'getCategoryRecipeFilterUrl'
        ],
        components: {
            'recipe-card' : RecipeCardComponent
        },
        data() {
            return {
                recipe_categories: [],
                category_recipes: [],
                recipe_category_filter: [],
                is_category_loading: false,
                is_recipe_loading: true
            }
        },
        watch: {
            recipe_category_filter: function(newValue) {
                let me = this;
                this.is_recipe_loading = true;
                axios.get(this.getCategoryRecipeFilterUrl, {
                    params: {
                        ids: this.recipe_category_filter
                    }
                }).then(function (response) {
                        me.category_recipes = response.data.filtered_recipes;
                        me.is_recipe_loading = false;
                    }).catch(function (error){

                })
            },
        },
        mounted () {
            this.getRecipeCategories();
            this.getCategoryRecipes();
        },
        methods: {
            getRecipeCategories() {
                let me = this;

                this.is_category_loading = true;
                axios.get(this.getRecipeCategoriesUrl)
                    .then(function (response) {
                        me.recipe_categories = response.data.recipe_categories;
                        me.is_category_loading = false
                    })
                    .catch(function (error){

                    });
            },
            getCategoryRecipes() {
                let me = this;

                this.is_recipe_loading = true;
                axios.get(this.getCategoryRecipeListUrl)
                    .then(function (response) {
                        me.category_recipes = response.data.category_recipes;
                        me.is_recipe_loading = false;
                    }).catch(function (error){

                })
            },
            load_more (category) {
                let me = this;

                category.skip_count++;
                category.skip = category.skip_count * category.take;
                console.log(category.skip_count);

                axios.get(this.getCategoryRecipeLoadUrl, {
                    params: {
                        category_id: category.id,
                        skip: category.skip,
                        take: category.take
                    }
                })
                    .then(function (response) {
                        me.category_recipes.filter(function(main_category){
                            if (main_category.id === category.id) {
                                for(let i=0; i < response.data.load_more_category_recipe.recipes.length; i++)
                                {
                                    main_category.recipes.push(response.data.load_more_category_recipe.recipes[i]);
                                }
                            }
                        });
                    }).catch(function (){

                })
            },
            clearAll () {
                this.recipe_category_filter = [];
            }
        }
    }
</script>

<style scoped>

</style>